import React, { Component } from "react";
import { connect } from "react-redux";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { toggleNav } from "./redux/actions/miscActions";
import { getProducts, getPakketten } from "./redux/actions/productActions";
import "antd/dist/antd.css";
import "./App.css";

import Admin from "./components/admin/Admin";

import Footer from "./components/layout/Footer";
import Navbar from "./components/layout/Navbar";
import SideBar from "./components/utils/SideBar";
import MessageModal from "./components/utils/MessageModal";
import Shop from "./components/shop/Shop";
import UtilModal from "./components/utils/UtilModal";
import User from "./components/auth/User";
import Cart from "./components/shop/Cart";
import Checkout from "./components/shop/Checkout";
import PrivateRoute from "./utils/PrivateRoute";
import AdminLogin from "./components/admin/layout/AdminLogin";
import EditModal from "./components/admin/ulits/EditModal";
import Order from "./components/admin/ulits/Order";
import EditPakketModal from "./components/admin/ulits/EditPakketModal";
import Pakketten from "./components/shop/Pakketten";
import ZuivelProducten from "./components/shop/ZuivelProducten";

import AdminRoute from "./utils/AdminRoute";

export class App extends Component {
  componentDidMount = () => {
    const { pathname } = window.location;
    if (pathname === "/" || pathname === "/shop" || pathname === "/pakketten" || pathname === "/zuivel-producten") {
      this.props.toggleNav(true);
    }
  };
  
  componentDidUpdate=()=>{
    const { pathname } = window.location;
    if(pathname.includes('admin') === false){
      this.props.getProducts();
      this.props.getPakketten();
    }
  }

  render() {
    const { isMainNavVisible } = this.props.misc;
    const showNav = isMainNavVisible ? <Navbar /> : null;
    const showFooter = isMainNavVisible ? <Footer /> : null;
    return (
      <div className="App">
        <Router>
          <UtilModal />
          <MessageModal />
          <SideBar />
          <Order />
          <EditModal />
          <EditPakketModal />
          {showNav}
          <Route exact path="/" component={Shop} />
          <Route exact path="/pakketten" component={Pakketten} />
          <Route exact path="/zuivel-producten" component={ZuivelProducten} />
          <Route exact path="/cart" component={Cart} />
          <Route exact path="/checkout" component={Checkout} />
          <Route exact path="/admin-login" component={AdminLogin} />          
            

          <Switch>
            <PrivateRoute exact path="/user" component={User} />
            <AdminRoute exact path='/admin/:params' component={Admin}/>
          </Switch>
          {showFooter}
        </Router>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  misc: state.misc,
});

export default connect(mapStateToProps, { toggleNav, getProducts, getPakketten })(App);
